import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { translations, LANGUAGES } from "@/i18n/translations";

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => {
    const saved = typeof window !== "undefined" ? localStorage.getItem("herblabs_lang") : null;
    return saved && translations[saved] ? saved : "en";
  });

  useEffect(() => {
    localStorage.setItem("herblabs_lang", lang);
    const meta = LANGUAGES.find((l) => l.code === lang);
    const dir = meta?.dir || "ltr";
    document.documentElement.setAttribute("lang", lang);
    document.documentElement.setAttribute("dir", dir);
  }, [lang]);

  // t("contact.name") -> string, falls back to English then key.
  const t = useCallback(
    (path) => {
      const get = (obj) => path.split(".").reduce((o, k) => (o ? o[k] : undefined), obj);
      return get(translations[lang]) ?? get(translations.en) ?? path;
    },
    [lang]
  );

  return (
    <LanguageContext.Provider value={{ lang, setLang, t, languages: LANGUAGES }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLang() {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLang must be used within LanguageProvider");
  return ctx;
}
